module.exports = __webpack_public_path__ + "img/ic_fitnessplan_empty.cc0d1c66.svg";